export default "__VITE_ASSET__CKhHf_yH__"